import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "PLMDataSheet/";

const getPLMDataSheetById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetPLMDataSheetById?jobFormId=' + id, constants.REQUIRE_INTERCEPTORS);

const getHANumberById = async (haNumber,id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetHANumberById?haNumber=' + haNumber + '&jobFormId=' + id, constants.REQUIRE_INTERCEPTORS);

const start = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'Start', model, constants.REQUIRE_INTERCEPTORS);

const save = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'Save', model, constants.REQUIRE_INTERCEPTORS);

const updateHANumber = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'UpdateHANumber', model, constants.REQUIRE_INTERCEPTORS);

const saveLineItem = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveLineItem', model, constants.REQUIRE_INTERCEPTORS);

const getReportPdf = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetReportPdf?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getACMLogForm = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetACMLogReport?id=' + id, constants.REQUIRE_INTERCEPTORS);

const deleteLineItem = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteLineItem?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getHANumberList = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetHANumberListing?jobFormId=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getPLMDataSheetById,
    getHANumberList,
    getHANumberById,
    start,
    save,
    updateHANumber,
    saveLineItem,
    getReportPdf,
    getACMLogForm,
    deleteLineItem
}